import React from 'react';
import classes from './style.module.css'

const InfoText = props => {
   return (
       <div className={classes.InfoText}>
            <span>Performance on: <strong>{props.placeholder}</strong>. All Times are in <strong>GMT</strong></span>
       </div>
   );
}

export default InfoText;